import React, { useState } from 'react';
import { Shield, Key, X } from 'lucide-react';
import { API_URL } from '../../config';

export default function TwoFactorGate({ onVerified, onCancel, title = "2FA erforderlich" }) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const formRef = React.useRef(null);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('snapshot_token');
      const res = await fetch(`${API_URL}/api/auth/2fa/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ code })
      });

      if (res.ok) {
        onVerified();
      } else {
        const data = await res.json();
        setError(data.detail || 'Ungültiger Code');
      }
    } catch (err) {
      setError('Netzwerkfehler');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[200] flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-black/95 to-black/90 border-2 border-[#10B981]/30 rounded-2xl p-8 max-w-md w-full relative">
        
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/20 text-white hover:bg-white/10 transition-all"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <Shield className="w-8 h-8 text-[#10B981]" />
            <h2 className="text-2xl font-bold text-white">{title}</h2>
          </div>
          <p className="text-white/60 text-sm">Gib deinen 6-stelligen Code ein</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-500 text-sm">
            {error}
          </div>
        )}

        <form ref={formRef} onSubmit={handleVerify} className="space-y-4">
          <div>
            <label className="block text-white/80 text-sm mb-2">2FA-Code oder Backup-Code</label>
            <div className="relative">
              <Key className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#10B981]/50" />
              <input
                type="text"
                value={code}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9-]/g, '').slice(0, 9);
                  setCode(val);
                  // Auto-Submit bei 6 Ziffern (nur TOTP, nicht Backup-Codes mit Bindestrich)
                  if (val.length === 6 && !val.includes('-')) {
                    setTimeout(() => formRef.current?.requestSubmit(), 50);
                  }
                }}
                required
                className="w-full pl-12 pr-4 py-3 bg-black/50 border-2 border-[#10B981]/30 rounded-lg text-white text-center text-2xl tracking-widest focus:border-[#10B981] transition-all"
                placeholder="123456"
                autoFocus
              />
            </div>
            <p className="text-white/40 text-xs mt-1">6-stelliger Code oder Backup-Code (1234-5678)</p>
          </div>

          <button
            type="submit"
            disabled={loading || code.length < 6}
            className="w-full py-3 bg-gradient-to-r from-[#10B981] to-[#059669] text-black rounded-lg font-bold disabled:opacity-50"
          >
            {loading ? 'Prüfe...' : 'Verifizieren'}
          </button>
        </form>

      </div>
    </div>
  );
}
